@if(wizardStore.G().form; as formGroup){
<form [formGroup]="formGroup">
  <app-card [titleKey]="translationKey + 'formTitle'">
    <app-info-label [label]="translationKey + 'formInfo'" />

    <app-validated-dropdown
      [label]="translationKey + 'loanCoverage'"
      inputFormControlName="loanCoverage"
      [inputFormControl]="formGroup.controls.loanCoverage"
      [optionsStamp]="genericProjectStore.projectLoanCoverageEntities().length"
    >
      @for (loanCoverage of genericProjectStore.projectLoanCoverageEntities();
      track $index) {
      <option [value]="loanCoverage.id">
        {{ loanCoverage.description }}
      </option>
      }
    </app-validated-dropdown>

    <app-validated-dropdown
      [label]="translationKey + 'loanUsage'"
      inputFormControlName="loanUsage"
      [inputFormControl]="formGroup.controls.loanUsage"
      [optionsStamp]="genericProjectStore.projectLoanUsageEntities().length"
    >
      @for (loanUsage of genericProjectStore.projectLoanUsageEntities(); track
      $index) {
      <option [value]="loanUsage.id">
        {{ loanUsage.description }}
      </option>
      }
    </app-validated-dropdown>

    <app-validated-dropdown
      [label]="translationKey + 'loanTerm'"
      inputFormControlName="loanTerm"
      [inputFormControl]="formGroup.controls.loanTerm"
      [optionsStamp]="genericProjectStore.projectLoanTermEntities().length"
    >
      @for (loanTerm of genericProjectStore.projectLoanTermEntities(); track
      $index) {
      <option [value]="loanTerm.id">
        {{ loanTerm.name }}
      </option>
      }
    </app-validated-dropdown>

    <app-validated-dropdown
      [label]="translationKey + 'loanInterestRatesType'"
      inputFormControlName="loanInterestRatesType"
      [inputFormControl]="formGroup.controls.loanInterestRatesType"
      [optionsStamp]="
        genericProjectStore.projectLoanInterestRatesTypeEntities().length
      "
    >
      @for (loanInterestRate of
      genericProjectStore.projectLoanInterestRatesTypeEntities(); track $index)
      {
      <option [value]="loanInterestRate.id" [title]="loanInterestRate.description">
        {{ loanInterestRate.name }}
      </option>
      }
    </app-validated-dropdown>

    <app-validated-dropdown
      [label]="translationKey + 'loanInterestPaymentType'"
      inputFormControlName="loanInterestPaymentType"
      [inputFormControl]="formGroup.controls.loanInterestPaymentType"
      [optionsStamp]="
        genericProjectStore.projectLoanInterestPaymentTypeEntities().length
      "
    >
      @for (loanInterestPayment of
      genericProjectStore.projectLoanInterestPaymentTypeEntities(); track
      $index) {
      <option [value]="loanInterestPayment.id" [title]="loanInterestPayment.description">
        {{ loanInterestPayment.name }}
      </option>
      }
    </app-validated-dropdown>

    <app-validated-input
      [label]="'general.runtime'"
      inputFormControlName="loanLengthMonths"
      [inputFormControl]="formGroup.controls.loanLengthMonths"
    />

    <app-validated-textarea
      [label]="'general.condition'"
      inputFormControlName="conditions"
      [inputFormControl]="formGroup.controls.conditions"
      [rows]="10"
    />

    <hr />

    <app-applicable-interest-rates
      [formControls]="formGroup.controls.loanInterests"
      [title]="'general.applicableInterestRate'"
      [canAdd]="true"
      (createNewFileGroup)="addNewApplicbleInterestRate()"
      (rowRemoveClicked)="removeRow($event)"
    />
    <hr />
    <div class="my-2">
      <label class="section-label">{{
        translationKey + "sectionOne" | translate
      }}</label>
    </div>

    <app-info-label [label]="translationKey + 'sectionOneInfo'" />

    <hr />

    <div class="my-2">
      <label class="sub-section-label">{{
        translationKey + "sectionOneSubOne" | translate
      }}</label>
    </div>

    <app-validated-dropdown
      [label]="'general.additionalAssurance'"
      inputFormControlName="additionalAssurance"
      [inputFormControl]="formGroup.controls.additionalAssurance"
      [haveEmptyOption]="false"
    >
      <option [value]="false">{{ "general.no" | translate }}</option>
      <option [value]="true">{{ "general.yes" | translate }}</option>
    </app-validated-dropdown>

    @if (isYes(formGroup.controls.additionalAssurance.value)) {
      <div>
        <label class="sub-section-label">{{
          translationKey + "guaranteeData" | translate
        }}</label>
      </div>

      <app-form-array-card
        [title]="translationKey + 'collateralProvider'"
        [formArray]="formGroup.controls.collateralProviders"
        [addButtonTitle]="translationKey + 'addCollateralProvider'"
        (add)="addCollateralProvider()"
        (remove)="removeCollateralProvider($event)"
      >
        <ng-template let-formGroup>
          <app-legal-person-validated-form
            [formGroupInput]="formGroup.controls.legalEntity"
            [showFillDataButton]="true"
            [showBankAccount]="false"
          />
        </ng-template>
      </app-form-array-card>

      <app-validated-textarea
        [label]="translationKey + 'collateralInfo'"
        inputFormControlName="collateralInfo"
        [inputFormControl]="formGroup.controls.collateralInfo"
        [rows]="10"
        [maxLength]="2000"
      />

      <hr />
    }

    <div>
      <label class="sub-section-label">{{
        translationKey + "sectionOnSubTwo" | translate
      }}</label>
    </div>

    <app-validated-dropdown
      [label]="translationKey + 'additionalGuarantee'"
      inputFormControlName="additionalGuarantee"
      [inputFormControl]="formGroup.controls.additionalGuarantee"
      [haveEmptyOption]="false"
    >
      <option [value]="false">{{ "general.no" | translate }}</option>
      <option [value]="true">{{ "general.yes" | translate }}</option>
    </app-validated-dropdown>

    @if (isYes(formGroup.controls.additionalGuarantee.value)) {
      <div>
        <label class="sub-section-label">{{
          translationKey + "guaranteeData" | translate
        }}</label>
      </div>

      <app-form-array-card
        [title]="translationKey + 'guarantor'"
        [formArray]="formGroup.controls.guarantors"
        [addButtonTitle]="translationKey + 'addGuarantor'"
        (add)="addGuarantor()"
        (remove)="removeGuarantor($event)"
      >
        <ng-template let-formGroup>
          <app-guarantor-form [formGroup]="formGroup" />
        </ng-template>
      </app-form-array-card>

      <app-validated-textarea
        [label]="translationKey + 'suretyInfo'"
        inputFormControlName="suretyInfo"
        [inputFormControl]="formGroup.controls.suretyInfo"
        [rows]="10"
        [maxLength]="2000"
      />

      <hr />
    }

    <div>
      <label class="sub-section-label">{{
        translationKey + "sectionOnSubThree" | translate
      }}</label>
    </div>

    <app-validated-dropdown
      [label]="translationKey + 'otherGuarantee'"
      inputFormControlName="otherGuarantee"
      [inputFormControl]="formGroup.controls.otherGuarantee"
      [haveEmptyOption]="false"
    >
      <option [value]="false">{{ "general.no" | translate }}</option>
      <option [value]="true">{{ "general.yes" | translate }}</option>
    </app-validated-dropdown>

    @if (isYes(formGroup.controls.otherGuarantee.value)) {
      <div>
        <label class="sub-section-label">{{
          translationKey + "guaranteePersonInfo" | translate
        }}</label>
      </div>

      <app-form-array-card
        [title]="translationKey + 'guaranteeProvider'"
        [formArray]="formGroup.controls.guarateeProviders"
        [addButtonTitle]="translationKey + 'addGuaranteeProvider'"
        (add)="addGuaranteeProvider()"
        (remove)="removeGuaranteeProvider($event)"
      >
        <ng-template let-formGroup>
          <app-legal-person-validated-form
            [formGroupInput]="formGroup.controls.legalEntity"
            [showFillDataButton]="true"
            [showBankAccount]="false"
          />
        </ng-template>
      </app-form-array-card>

      <app-validated-textarea
        [label]="translationKey + 'guaranteeInfo'"
        inputFormControlName="guaranteeInfo"
        [inputFormControl]="formGroup.controls.guaranteeInfo"
        [rows]="10"
        [maxLength]="2000"
      />

      <hr />
    }

    <div>
      <label class="section-label">{{
        translationKey + "sectionTwo" | translate
      }}</label>
    </div>
    <app-info-label [label]="translationKey + 'sectionTwoInfo'" />

    <app-validated-dropdown
      [label]="translationKey + 'capitalRepayment'"
      inputFormControlName="capitalRepayment"
      [inputFormControl]="formGroup.controls.capitalRepayment"
      [optionsStamp]="
        genericProjectStore.loanTypePaymentFrequencyEntities().length
      "
    >
      @for (freq of genericProjectStore.loanTypePaymentFrequencyEntities();
      track freq.id) {
        <option [value]="freq.id">
          {{ "generic.loanTypePaymentFrequency." + freq.name | translate }}
        </option>
      }
    </app-validated-dropdown>

    <app-validated-dropdown
      [label]="translationKey + 'interestRepayment'"
      inputFormControlName="interestRepayment"
      [inputFormControl]="formGroup.controls.interestRepayment"
      [optionsStamp]="
        genericProjectStore.loanTypePaymentFrequencyEntities().length
      "
    >
      @for (freq of genericProjectStore.loanTypePaymentFrequencyEntities();
      track freq.id) {
        <option [value]="freq.id">
          {{ "generic.loanTypePaymentFrequency." + freq.name | translate }}
        </option>
      }
    </app-validated-dropdown>

    <app-validated-dropdown
      [label]="translationKey + 'notCompletedProjectWithinFiveYears'"
      inputFormControlName="notCompletedProjectWithinFiveYears"
      [inputFormControl]="formGroup.controls.notCompletedProjectWithinFiveYears"
      [haveEmptyOption]="false"
    >
      <option [value]="false">{{ "general.no" | translate }}</option>
      <option [value]="true">{{ "general.yes" | translate }}</option>
    </app-validated-dropdown>

    @if (isYes(formGroup.controls.notCompletedProjectWithinFiveYears.value)) {
      <hr />
      <div>
        <label class="section-label">{{
          translationKey + "notCompletedLoanData" | translate
        }}</label>
      </div>

      <app-form-array-card
        [title]="translationKey + 'notCompletedLoan'"
        [formArray]="formGroup.controls.notCompletedLoans"
        [addButtonTitle]="translationKey + 'addNotCompletedLoan'"
        (add)="addNotCompletedLoan()"
        (remove)="removeNotCompletedLoan($event)"
      >
        <ng-template let-formGroup>
          <app-not-completed-loan-form [formGroup]="formGroup" />
        </ng-template>
      </app-form-array-card>

      <app-validated-textarea
        [label]="translationKey + 'notCompletedInfo'"
        inputFormControlName="notCompletedInfo"
        [inputFormControl]="formGroup.controls.notCompletedInfo"
        [rows]="10"
        [maxLength]="2000"
      />

      <hr />
    }
    <div>
      <label class="section-label">{{
        translationKey + "sectionThree" | translate
      }}</label>
    </div>

    <app-validated-textarea
      [label]="translationKey + 'loanHandlingInfo'"
      inputFormControlName="loanHandlingInfo"
      [inputFormControl]="formGroup.controls.loanHandlingInfo"
      [rows]="10"
      [maxLength]="2000"
    />
  </app-card>
</form>

}
